import React, { useState, useEffect, useRef } from 'react';
import classes from './HeaderNav.module.css';
import logo from '../../../../Assets/rotating-logo.png';
import icon from '../../../../Assets/Component 1 (4).png';
import iconinactive from '../../../../Assets/dshbrd-inactive.png';
import trsanstin from '../../../../Assets/cardtrsnct.png';
import RotatingLogo from '../../../../Assets/rotating-logo.png'
import trsanstinactive from '../../../../Assets/Component 1 (3).png';
import acctn from '../../../../Assets/Accountingicon.png';
import acctnactive from '../../../../Assets/Component 1 (2).png';
import rprts from '../../../../Assets/reportsicon.png';
import rprtsactive from '../../../../Assets/Component 1 (6).png';
import bnkn from '../../../../Assets/bankin-icon.png';
import bnknactive from '../../../../Assets/Component 1 (7).png';
import stngs from '../../../../Assets/settings-icon.png';
import stngsactive from '../../../../Assets/Component 1 (8).png';
import CurrencyInput from 'react-currency-input-field';
import { Dropdown, Col, Row, Button, Modal, Form, Spinner, Badge } from 'react-bootstrap';
import Select from 'react-select';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaBars, FaTimes } from "react-icons/fa";
import { CiMenuFries } from "react-icons/ci";
import { FaRegTimesCircle } from "react-icons/fa";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import JournalModal from "./Journal/Journal";

import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../../../Components/Styles/API/API';
import RemitanceUpload from './Journal/RemittanceUpload';

export default function HeaderNav() {
  const location = useLocation();
  const [teller, setTeller] = useState("")
  const [user, setUser] = useState('');
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState('');
  const userDropdownRef = useRef(null);
  const [showRemittanceExcelModal, setShowRemittanceExcelModal] = useState(false);
  const [showRemittanceModal, setShowRemittanceModal] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const navigate = useNavigate();
  const [monthLoading, setMonthLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [show2648, setShow2648] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [createLoading, setCreateLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [company, setCompany] = useState('');
  const [userType, setUserType] = useState('');
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [interest, setInterest] = useState(0.00);
  const [totalRepayment, setTotalRepayment] = useState(0.00);
  const [monthlyDeduction, setMonthlyDeduction] = useState('');
  const [duration, setDuration] = useState('');
  const [province, setProvince] = useState('');
  const [validity, setValidity] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [description, setDescription] = useState("");
  const [outstanding, setOutstanding] = useState("");
  const [currMonth, setCurrMonth] = useState('');
  const [loading, setLoading] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [loans, setLoans] = useState([]);
  const [openJournalModal, setOpenJournalModal] = useState(false);

  const toggleNav = () => setNavOpen(!navOpen);
  const handleCustomerChange = (selectedOption) => {
    setSelectedCustomer(selectedOption.value);
    setOutstanding(selectedOption.balance);
  };

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value9 = await localStorage.getItem('userEmail');
      const value7 = await localStorage.getItem('companyName');
      const value8 = await localStorage.getItem('validity');
      const curr = await localStorage.getItem('currentMonth');

      if (value !== null && value.trim() !== '') {
        setBearer(value);
      } else {
        navigate('/login');
        return;
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (value9 !== null) {
        setUserEmail(value9);
      }
      if (value8 !== null) {
        setValidity(value8);
      }
      if (value7 !== null) {
        setCompany(value7);
      }
      if (curr !== null) {
        console.log(curr);
        const date = new Date(curr);
        setCurrMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${bearer}`,
  };

  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const handlePaymentModeChange = (event) => {
    setSelectedPaymentMode(event.target.value);
  };
  const [paymentMethod, setPaymentMethod] = useState([]);

  const fetchPaymentMethod = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/income/get-payment-method`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );
      const resultss = response.data?.data;
      setPaymentMethod(resultss);
      console.log(resultss, "PaymentModes");
    } catch (error) {
      const errorStatus = error.response.data.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

  const [incomeAmount, setIncomeAmount] = useState();
  const handleValueChanges = (value) => {
    setIncomeAmount(value);
  };

  const navItems = [
    { label: 'Dashboard', path: '/admin', icon: iconinactive, activeIcon: icon },
    { label: 'Administration', path: '/accounting/continent', icon: stngs, activeIcon: stngsactive },
    { label: 'Operations', path: '/accounting/customers', icon: trsanstin, activeIcon: trsanstinactive },
    { label: 'Transactions', path: '/accounting/supplier', icon: acctn, activeIcon: acctnactive },
    { label: 'Accounts', path: '/budget/chart_of_account', icon: bnkn, activeIcon: bnknactive },
    { label: 'Reports', path: '/budget/finance-statement', icon: bnkn, activeIcon: bnknactive },
  ];

  const dropdownMenus = {
    Administration: [
      { label: 'Manage Currency Rate', path: '/admin/exchange_rate' },
      { label: 'Manage Tax', path: '/admin/Tax',  },
      { label: 'Manage Continents', path: '/admin/continent' },
      { label: 'Manage Regions', path: '/admin/region' },
      { label: 'Manage Province', path: '/admin/province' },
      { label: 'Manage User', path: '/admin/manage_user' },
      { label: 'Compliance-Province Assignment ', path: '/admin/complianceProvince' },
      // { label: 'Accountant- Province Assignment ', path: '/admin/accountant_province' },
      { label: 'Audit-Province Assignment ', path: '/admin/auditProvince' },


    ],
    Operations: [

      { label: 'Pending Working Month Request', path: '/admin/change_working_month_pending' },
      { label: 'Reset Working Month Request', path: '/accounting/reset_working_month' },
      { label: 'Approved Working Month Request', path: '/admin/change_working_month_approval' },
      { label: 'Disapproved Working Month Request', path: '/admin/change_working_month_disapprove' },
      { label: 'Pending Accounts', path: '/admin/operations/account' },
      { label: 'Approved Accounts', path: '/admin/operations/approved_account' },
      { label: 'Disapproved Accounts', path: '/admin/operations/disapproved_account' },

    ],
    'Transactions': [
      { label: 'Receipts', path: '/admin/cash_management' },
      { label: 'Expenses', path: '/admin/expenses' },
      { label: 'Lodged Transactions', path: '/admin/lodged_transactions' },
      { label: 'Budget', path: '/admin/budget' },
      { label: 'Payroll', path: '/admin/payroll' },
    ],
    Accounts: [
      { label: 'Account Category', path: '/budget/account_category' },
      { label: 'Chart of Accounts', path: '/budget/chart_of_account' },
    ],
    'Reports': [
      { label: "Financial Report", path: '/budget/finance-statement' },
      { label: "Provincial Record", path: '/admin/ProvinceRecords' },
      { label: "Reconciliation Summary Report", path: '/admin/summary_report' },
      { label: "Outstanding Items Report", path: '/admin/bank_reconciliationnew' },
      { label: "Province Status Report", path: '/provincestatus_reports' },
    ],
    Accounting: [
      { label: 'Journal Entries', path: '/accounting/view_journal_entries' },
      { label: 'Search Account Journal', path: '/accounting/search_account_journals' },
      { label: 'Upload Opening Balance - Excel', path: '/accounting/upload_opening_balance' },
      { label: 'Upload Opening Balance - Bulk', path: '/accounting/upload_opening_balance_bulk' },
      { label: 'Upload Journal Entry', path: '/accounting/upload_journal_entry' },
      { label: 'Upload National Journal Entry', path: '/accounting/national/upload_journal_entry' },
      { label: 'Charts of Account', path: '/accounting/charts_of_account/account' },
      { label: 'Pending Account Approvals', path: '/accounting/account_approvals' },
      { label: 'Disapproved Account', path: '/accounting/account_dispproved' },
    ],
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const dropdownContainer = document.querySelector(`.${classes.dropdown}`);
      if (dropdownContainer && !dropdownContainer.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // const handleLogout = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.post(
  //       `${BASE_URL}/logout`,
  //       {},
  //       { headers }
  //     );
  //     navigate('/login');
  //   } catch (error) {
  //     let errorMessage = 'An error occurred. Please try again.';
  //     if (error.response && error.response.data && error.response.data.message) {
  //       if (typeof error.response.data.message === 'string') {
  //         errorMessage = error.response.data.message;
  //       } else if (Array.isArray(error.response.data.message)) {
  //         errorMessage = error.response.data.message.join('; ');
  //       } else if (typeof error.response.data.message === 'object') {
  //         errorMessage = JSON.stringify(error.response.data.message);
  //       }
  //     }
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Failed',
  //       text: errorMessage,
  //     });
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleLogout = () => {
    navigate('/');
  };

  const changePassword122 = async () => {
    setCreateLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/change_password`,
        {
          current_password: currentPassword,
          new_password: password,
          password_confirmation: passwordConfirmation,
        },
        { headers }
      );
      setCurrentPassword('');
      setPassword('');
      setPasswordConfirmation('');
      setShow(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setCreateLoading(false);
    }
  };

  const getNextMonthName = (currMonth) => {
    const date = new Date(currMonth);
    let nextMonth = date.getMonth() + 1;
    if (nextMonth > 11) {
      nextMonth = 0;
    }
    const nextMonthDate = new Date(date.getFullYear(), nextMonth, 1);
    const nextMonthName = nextMonthDate.toLocaleString("default", {
      month: "long",
    });
    return nextMonthName;
  };

  const getPrevMonthName = (currMonth) => {
    const date = new Date(currMonth);
    let prevMonth = date.getMonth() - 1;
    if (prevMonth < 0) {
      prevMonth = 11;
      date.setFullYear(date.getFullYear() - 1);
    }
    const prevMonthDate = new Date(date.getFullYear(), prevMonth, 1);
    const prevMonthName = prevMonthDate.toLocaleString("default", {
      month: "long",
    });
    return prevMonthName;
  };

  const getCurrentMonthName = (currMonth) => {
    const date = new Date(currMonth);
    const currentMonthName = date.toLocaleString("default", { month: "long" });
    return currentMonthName;
  };

  useEffect(() => {
    if (bearer) {
      fetchPaymentMethod();
    }
  }, [bearer]);

  const [isLoading, setIsLoading] = useState(false);
  const [loanInterest, setLoanInterest] = useState(0.00);
  const [cus, setCus] = useState([]);

  const fetchSupplierss = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/loan-customers`, { headers });
      const results = response.data?.data?.data;
      const options = results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setCustomers(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCustomers([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCustomers = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
      const results = response.data?.data;
      const options = results.map((item) => ({
        label: item.name,
        value: item.id,
        balance: item.balance
      }));
      setCus(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCus([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLoans = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/fetch-loans`, { headers });
      const results = response.data?.data;
      const options1 = results.map((item) => ({
        label: item.description,
        value: item.id,
        interest: item.interest
      }));
      setLoans(options1);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setLoans([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchSupplierss();
      fetchLoans();
      fetchCustomers();
    }
  }, [bearer]);

  const [selectedLoan, setSelectedLoan] = useState(null);

  const handleLoanTypeChange = (selectedOption) => {
    setSelectedLoan(selectedOption.value);
    const selectedLoanInterest = selectedOption.interest;
    setLoanInterest(selectedLoanInterest === null ? "0.00" : selectedLoanInterest);
  };

  const handleTrashClick1 = async () => {
    const currentMonthName = getCurrentMonthName(currMonth);
    const nextMonthName = getNextMonthName(currMonth);
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to change your working month from ${currentMonthName} to ${nextMonthName}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Change it!",
      cancelButtonText: "No, Cancel",
    });

    if (!confirmed.isConfirmed) {
      return;
    }

    Swal.fire({
      title: "Changing the working month...",
      text: "Please wait while we process your request.",
      icon: "info",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    setMonthLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/provinces/update-province-month`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${bearer}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });
      navigate("/login");
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setMonthLoading(false);
    }
  };

  const handleTrashClick2 = async () => {
    const currentMonthName = getCurrentMonthName(currMonth);
    const prevMonthName = getPrevMonthName(currMonth);
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to reset your working month from ${currentMonthName} to ${prevMonthName}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reset it!",
      cancelButtonText: "No, Cancel",
    });

    if (!confirmed.isConfirmed) {
      return;
    }

    Swal.fire({
      title: "Resetting the working month...",
      text: "Please wait while we process your request.",
      icon: "info",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    setMonthLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/provinces/reverse-province-month`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${bearer}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });
      navigate("/login");
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setMonthLoading(false);
    }
  };

  const getInitials = (name) => {
    const parts = name?.trim().split(' ');
    const firstTwo = parts?.slice(0, 2);
    return firstTwo.map((part) => part.charAt(0).toUpperCase()).join('');
  };

  const initials = getInitials(user);

  const [showLoanModal, setShowLoanModal] = useState(false);
  const handleClose = () => {
    setShowLoanModal(false);
  };

  const [showCustomer, setShowCustomer] = useState(false);
  const handleCloseCustomer = () => setShowCustomer(false);
  const handleShowCustomer = () => {
    setShowCustomer(true);
    handleClose();
  }
  const [selectedImage, setSelectedImage] = useState('');

  const createLoans = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('doc', selectedImage);
      formData.append("loan_name", selectedLoan);

      const response = await axios.post(
        `${BASE_URL}/account/upload-staff-loan-payment`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      handleCloseCustomer();
      setSelectedImage("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const [selectedDatess, setSelectedDatess] = useState('');
  const handleDateChangess = (event) => {
    setSelectedDatess(event.target.value);
  };

  const handleSupplierChange = (selectedOption) => {
    setSelectedCustomer(selectedOption.value);
  }

  const [principalAmount, setPrincipalAmount] = useState('');

  const handleValueChange = (value, name, values) => {
    setPrincipalAmount(value);
  };

  const handleValueChange1 = (value, name, values) => {
    setLoanInterest(value);
  };

  const handleValueChange2 = (value, name, values) => {
    setInterest(value);
  };

  const [banks, setBanks] = useState([]);
  const [selectedBanks, setSelectedBanks] = useState(null)

  const handleBankChange = (selectedOption) => {
    setSelectedBanks(selectedOption);
  }

  const fetchBanks = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
      const results = response.data?.data;
      const options1 = results.map((item) => ({
        label: item.gl_name,
        value: item.id,
      }));
      setBanks(options1);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setBanks([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchBanks();
    }
  }, [bearer]);

  const handlePaymentChange = (selectedOption) => {
    if (selectedOption) {
      const selectedValue = selectedOption.value;
      console.log('Selected value:', selectedValue);
      setSelectedBanks(selectedValue);
    } else {
      console.error('Selected option is undefined');
    }
  };

  const handleValueChange3 = (value, name, values) => {
    setTotalRepayment(value);
  };

  const handleValueChange4 = (value, name, values) => {
    setMonthlyDeduction(value);
  };

  useEffect(() => {
    const calculateInterestRate = () => {
      const calculatedInterestRate = (parseFloat(loanInterest) / 100) * parseFloat(principalAmount);
      const formattedInterestRate = isNaN(calculatedInterestRate) ? "0.00" : calculatedInterestRate.toFixed(2);
      setInterest(formattedInterestRate);
    };
    calculateInterestRate();
  }, [loanInterest, principalAmount]);

  useEffect(() => {
    const calculateTotalRepayment = () => {
      const calculatedTotalRepayment = parseFloat(principalAmount) + parseFloat(interest);
      const formattedTotalRepayment = isNaN(calculatedTotalRepayment) ? "0.00" : calculatedTotalRepayment.toFixed(2);
      setTotalRepayment(formattedTotalRepayment);
    };
    calculateTotalRepayment();
  }, [interest, principalAmount]);

  useEffect(() => {
    const calculateReturn = () => {
      const calculatedReturn = parseFloat(totalRepayment) / parseFloat(duration);
      const formattedReturn = isNaN(calculatedReturn) ? "0.00" : calculatedReturn.toFixed(2);
      setMonthlyDeduction(formattedReturn);
    };
    calculateReturn();
  }, [totalRepayment, duration]);

  const createLoan = async () => {
    setCreateLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/account/staff-loan`,
        {
          member_name: selectedCustomer || '',
          loan_name: selectedLoan || '',
          bank: selectedBanks.value,
          principal_amount: principalAmount,
          interest_amount: interest,
          total_repayment: totalRepayment,
          monthly_deduction: monthlyDeduction,
          loan_interest: loanInterest,
          duration: duration,
          transaction_date: selectedDatess,
        },
        { headers }
      );
      console.log(response.data.message)
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      handleClose();

      setSelectedCustomer(null);
      setSelectedLoan(null);
      setSelectedBanks(null);
      setSelectedDatess('');
      setPrincipalAmount('');
      setLoanInterest('');
      setInterest('');
      setTotalRepayment('');
      setDuration('');
      setMonthlyDeduction('');
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          console.log(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: JSON.stringify(error.response.data.data),
      });
    } finally {
      setCreateLoading(false);
    }
  };

  // Upload Payables modals
  const [showTypeModal, setShowTypeModal] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [payableType, setPayableType] = useState("");
  const handleOpenUploadType = () => setShowTypeModal(true);
  const handleCloseTypeModal = () => setShowTypeModal(false);

  const handleSelectType = (type) => {
    setPayableType(type);
    setShowTypeModal(false);
    setShowFormModal(true);
  };

  const handleCloseFormModal = () => {
    setShowFormModal(false);
    setPayableType("");
  };

  const [debit1, setDebit1] = useState([]);
  const [debit2, setDebit2] = useState([]);
  const [debit3, setDebit3] = useState([]);
  const [debit4, setDebit4] = useState([]);

  const fetchDebit1 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/expenses`, { headers });
      const debt1 = response.data?.data;
      const oopt1 = debt1.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));
      setDebit1(oopt1);
    } catch (error) {
      const errorStatus = error.response.data.message;
    } finally {
      setLoading(false);
    }
  };

  const fetchDebit3 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
      const debt1 = response.data?.data;
      const oopt1 = debt1.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));
      setDebit3(oopt1);
    } catch (error) {
      const errorStatus = error.response.data.message;
    } finally {
      setLoading(false);
    }
  };

  const fetchDebit2 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/payables`, { headers });
      const debt2 = response.data?.data;
      const oopt2 = debt2.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));
      setDebit2(oopt2);
    } catch (error) {
      const errorStatus = error.response.data.message;
    } finally {
      setLoading(false);
    }
  };

  const fetchDebit4 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/cash`, { headers });
      const debt2 = response.data?.data;
      const oopt2 = debt2.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));
      setDebit4(oopt2);
    } catch (error) {
      const errorStatus = error.response.data.message;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchDebit1();
      fetchDebit2();
      fetchDebit3();
      fetchDebit4();
    }
  }, [bearer]);

  const [selectedExpenses, setSelectedExpenses] = useState('')
  const [date, setDate] = useState('')
  const [selectedImagesss, setSelectedImagesss] = useState('');
  const [selectedPayable, setSelectedPayable] = useState('')

  const handleImageChangessss = (event) => {
    const file = event.target.files[0];
    setSelectedImagesss(file);
  };

  const handledExpenses = (selectedOption) => {
    setSelectedExpenses(selectedOption.value);
  };

  const handlePayables = (selectedOption) => {
    setSelectedPayable(selectedOption.value);
  };

  const [tableData, setTableData] = useState([]);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState('');

  const fetchCharts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
      const results = response.data?.data;
      const opt1 = results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      console.log(response);
      setTableData(opt1);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchCharts();
    }
  }, [bearer]);

  const uploadStatement = async () => {
    setCreateLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedImagesss);
      formData.append('payable', selectedPayable);
      formData.append('expense', selectedExpenses);
      formData.append('transaction_date', date);

      const response = await axios.post(
        `${BASE_URL}/upload-payable-excel`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setSelectedImagesss("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const uploadRemittance = async () => {
    setCreateLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', excelFile);
      formData.append('bank', selectedBanks);
      formData.append('customer_id', selectedCustomer);
      formData.append('transaction_date', selectedDate);
      formData.append('cheque_number', teller);

      const response = await axios.post(
        `${BASE_URL}/upload_remittance_payment_new`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setSelectedImagesss("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const [create, setCreate] = useState(false);

  const createRemitance = async () => {
    setCreate(true);
    try {
      const formData = new FormData();
      formData.append('bank', selectedBanks);
      formData.append('customer_id', selectedCustomer);
      formData.append('transaction_date', date);
      formData.append('mode', selectedPaymentMode);
      formData.append('cheque_number', teller);
      formData.append('description', description);
      formData.append('amount', incomeAmount);

      const response = await axios.post(
        `${BASE_URL}/save-casual-payment`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreate(false);
    }
  };

  const uploadStatements = async () => {
    setCreateLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedImagesss);
      formData.append('payable', selectedPayable);
      formData.append('expense', selectedExpenses);
      formData.append('transaction_date', date);
      formData.append('beneficiary_id', selectedBeneficiary.value);

      const response = await axios.post(
        `${BASE_URL}/upload-beneficiary-payable-excel`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setSelectedImagesss("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  return (
    <div className={classes.entnav22}>
      <NavLink to="/admin">  <img src={logo} alt="Logo" className={classes.logo} /></NavLink>

      <div className={`${classes.headerNav} ${classes.desktopOnly}`}>
        {navItems.map((item) => {
          const isActive = location.pathname.startsWith(item.path);
          const hasDropdown = dropdownMenus[item.label];

          return hasDropdown ? (
            <div
              key={item.label}
              className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}
            >
              <div
                className={classes.dshbrdnavMain}
                onClick={() =>
                  setOpenDropdown(openDropdown === item.label ? null : item.label)
                }
              >
                <img
                  src={isActive ? item.activeIcon : item.icon}
                  alt={`${item.label} icon`}
                  className={classes.dshbrdicon}
                />
                <p
                  className={isActive ? classes.activeText : ''}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {item.label}
                </p>
              </div>
              {openDropdown === item.label && (
                <div className={classes.dropdown}>
                  {dropdownMenus[item.label].map((sub, index) =>
                    sub.children ? (
                      <div key={index} className={classes.dropdownWithSub}>
                        <span className={classes.dropdownItem}>{sub.label}</span>
                        <div className={classes.subDropdown}>
                          {sub.children.map((child, cIndex) => {
                            if (child.isUploadRemittanceExcel) {
                              return (
                                <div
                                  key={cIndex}
                                  className={classes.dropdownItem}
                                  onClick={() => {
                                    setShowRemittanceExcelModal(true);
                                    setOpenDropdown(null);
                                  }}
                                >
                                  {child.label}
                                </div>
                              );
                            }
                            if (child.isRemittanceModal) {
                              return (
                                <div
                                  key={cIndex}
                                  className={classes.dropdownItem}
                                  onClick={() => {
                                    setShowRemittanceModal(true);
                                    setOpenDropdown(null);
                                  }}
                                >
                                  {child.label}
                                </div>
                              );
                            }
                            return (
                              <NavLink
                                key={cIndex}
                                to={child.path}
                                onClick={() => setOpenDropdown(null)}
                                className={({ isActive }) =>
                                  `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ""}`
                                }
                              >
                                {child.label}
                              </NavLink>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      <div key={index}>
                        {sub.isUploadPayableModal ? (
                          <div
                            className={classes.dropdownItem}
                            onClick={() => {
                              handleOpenUploadType();
                              setOpenDropdown(null);
                            }}
                          >
                            {sub.label}
                          </div>
                        ) : sub.isUploadRemittanceExcel ? (
                          <div
                            className={classes.dropdownItem}
                            onClick={() => {
                              setShowRemittanceExcelModal(true);
                              setOpenDropdown(null);
                            }}
                          >
                            {sub.label}
                          </div>
                        ) : sub.isRemittanceModal ? (
                          <div
                            className={classes.dropdownItem}
                            onClick={() => {
                              setShowRemittanceModal(true);
                              setOpenDropdown(null);
                            }}
                          >
                            {sub.label}
                          </div>
                        ) : sub.isModal ? (
                          <div
                            className={classes.dropdownItem}
                            onClick={() => {
                              setShowLoanModal(true);
                              setOpenDropdown(null);
                            }}
                          >
                            {sub.label}
                          </div>
                        ) : sub.customAction ? (
                          <div
                            key={index}
                            className={classes.dropdownItem}
                            onClick={() => {
                              sub.customAction();
                              setTimeout(() => setOpenDropdown(null), 100);
                            }}
                          >
                            {sub.label}
                          </div>
                        ) : (
                          <NavLink
                            to={sub.path}
                            onClick={() => setOpenDropdown(null)}
                            className={({ isActive }) =>
                              `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ""}`
                            }
                          >
                            {sub.label}
                          </NavLink>
                        )}
                      </div>
                    )
                  )}
                </div>
              )}
            </div>
          ) : (
            <Link to={item.path} key={item.label} className={classes.link}>
              <div
                className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}
              >
                <img
                  src={isActive ? item.activeIcon : item.icon}
                  alt={`${item.label} icon`}
                  className={classes.dshbrdicon}
                />
                <p className={isActive ? classes.activeText : ''}>{item.label}</p>
              </div>
            </Link>
          );
        })}
      </div>

      {/* Rest of the modals and user section remain the same */}
      <Modal show={showTypeModal} onHide={handleCloseTypeModal} centered style={{ zIndex: 9999 }}>
        <Modal.Header closeButton>
          <Modal.Title>Select Payable Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column gap-2">
            <Button className={classes.sabtn} onClick={() => handleSelectType("Salary")}>
              Salary Payable
            </Button>
            <Button className={classes.btnpayab} onClick={() => handleSelectType("Pension")}>
              Pension / PAYE Payable
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Step 2: Upload Form */}
      <Modal show={showFormModal} onHide={handleCloseFormModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {payableType === "Salary"
              ? "Upload Salary Payable"
              : "Upload Pension / PAYE Payable"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              console.log("Submit", payableType);
              handleCloseFormModal();
            }}
          >
            {payableType === "Salary" && (
              <a style={{}} href={`https://account-api.patna.ng/api/v1/download-payable-excel`} download>
                <Button
                  className={classes.btntemp}
                  style={{ width: 200, height: "30px", padding: "0", borderRadius: 5, marginBottom: 10 }}  >
                  Download Template
                </Button>
              </a>
            )}
            {payableType === "Pension" && (
              <a style={{ marginLeft: 10 }} href={`https://account-api.patna.ng/api/v1/download-payable-excel`} download>
                <Button
                  className={classes.btntemp}
                  style={{ width: 200, height: "30px", padding: "0", borderRadius: 5, marginBottom: 10 }} variant='success' >
                  Download Template
                </Button>
              </a>
            )}
            <Modal.Footer />
            <Form.Group className="mb-3">
              <Form.Label>Payable Account</Form.Label>
              <Select isLoading={loading} options={debit2} onChange={handlePayables} placeholder='Select Payable Account'
                menuPortalTarget={document.body}
                styles={{
                  width: '80vh',
                  menuPortal: (base) => ({ ...base, zIndex: 9999, width: '40vh' }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: '300px',
                    maxWidth: '700px',
                    overflowY: 'auto',
                    marginLeft: '20px',
                  }),
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Expenses Account</Form.Label>
              <Select isLoading={loading} options={debit1} onChange={handledExpenses} placeholder='Select Expenses Account'
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999, width: '40vh' }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: '300px',
                    maxWidth: '700px',
                    overflowY: 'auto',
                  }),
                }}
              />
            </Form.Group>

            {payableType === "Pension" && (
              <Form.Group className="mb-3">
                <Form.Label>Select PFA/Tax Agents</Form.Label>
                <Select
                  value={selectedBeneficiary}
                  onChange={setSelectedBeneficiary}
                  options={tableData}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '300px',
                      maxWidth: '300px',
                      overflowY: 'auto',
                    }),
                  }}
                />
              </Form.Group>
            )}

            <Form.Group className="mb-3">
              <Form.Label>Date</Form.Label>
              <Form.Control type="date" min={minDate}
                max={maxDate} value={date} onChange={(e) => setDate(e.target.value)} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>File</Form.Label>
              <Form.Control
                type="file"
                placeholder="Choose file"
                accept=".xlsx"
                onChange={handleImageChangessss}
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={handleCloseFormModal}>
                Cancel
              </Button>
              <Button style={{ background: "linear-gradient(to bottom, var(--primary-color), var(--light-primary))" }} onClick={payableType === "Salary" ? uploadStatement : uploadStatements}  >
                {createLoading ? (
                  <>
                    <Spinner size='sm' />
                    <span style={{ marginLeft: '5px' }}>Uploading, Please wait...</span>
                  </>
                ) : (
                  "Upload"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Customer Modal */}
      <Modal show={showCustomer} onHide={handleCloseCustomer} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Loan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ marginTop: 20 }}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <div style={{ marginTop: 10 }} >
                <label for="example-text-input" style={{ textAlign: "right" }}>Loan Type</label>
                <div style={{ width: '100%' }}>
                  <Select
                    value={loans.find((l) => l.value === selectedLoan) || null}
                    onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
                    options={loans}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: '400px',
                        overflowY: 'auto',
                      }),
                    }}
                  />
                </div>
              </div>

              <div style={{ marginTop: 10, marginLeft: 7 }}>
                <Form.Label>File</Form.Label>
                <Form.Control
                  type="file"
                  placeholder="Choose file"
                  accept=".xlsx, .xls"
                  onChange={handleImageChange}
                />
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseCustomer}>
            Go back
          </Button>
          <Button variant="success"
            onClick={createLoans}
          >
            {loading ? (
              <>
                <Spinner size='sm' />
                <span style={{ marginLeft: '5px' }}>Uploading Loan, Please wait...</span>
              </>
            ) : (
              "Upload Loan"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Loan Modal */}
      <Modal size='lg' show={showLoanModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Loan Disbursement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <p style={{
              fontWeight: 'bold',
              marginBottom: 10,
              fontSize: 16,
              color: '#000'
            }}>Upload Loan Disbursement</p>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 10,
              marginBottom: 10
            }}>
              <div>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="download-tooltip">
                      Click here to download template
                    </Tooltip>
                  }
                >
                  <a href="https://account-api.patna.ng/api/v1/download-staff-loan-disbursement" download>
                    <div style={{
                      width: 200,
                      height: 40,
                      borderRadius: 8,
                      backgroundColor: '#fff',
                      border: '1px solid rgb(187, 183, 183)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}>
                      <p style={{
                        marginTop: -3,
                        color: '#000'
                      }}>Download Template</p>
                    </div>
                  </a>
                </OverlayTrigger>
              </div>
              <div>
                <OverlayTrigger
                  placement="top"
                  className={classes.btndf1}
                  overlay={<Tooltip id="button-tooltip" className={classes.btndf1}>Click here to upload loan</Tooltip>}
                >
                  <Button variant='success' className={classes.btn2} onClick={handleShowCustomer} >
                    Upload Loan
                  </Button>
                </OverlayTrigger>
              </div>
            </div>
            <Modal.Footer />
            {/* Rest of the loan form remains the same */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="transactionDate">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Transaction Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={selectedDatess}
                      onChange={handleDateChangess}
                      min={minDate}
                      max={maxDate}
                      required
                      style={{ flex: 1 }}
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="member">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Member
                    </Form.Label>
                    <div style={{ flex: 1 }}>
                      <Select
                        onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                        options={selectOptions}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: '300px',
                            overflowY: 'auto',
                          }),
                          control: (provided) => ({
                            ...provided,
                            width: '100%',
                          }),
                        }}
                      />
                    </div>
                  </div>
                </Form.Group>
              </div>
            </div>

            {/* Rest of the form fields remain the same */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="loanType">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Loan Type
                    </Form.Label>
                    <div style={{ flex: 1 }}>
                      <Select
                        onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
                        options={loans}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: '200px',
                            overflowY: 'auto',
                          }),
                          control: (provided) => ({
                            ...provided,
                            width: '100%',
                          }),
                        }}
                      />
                    </div>
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="principalAmount">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Principal Amount
                    </Form.Label>
                    <CurrencyInput
                      name="principal amount"
                      decimalsLimit={2}
                      className="form-control"
                      value={principalAmount}
                      onValueChange={handleValueChange}
                      style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
                    />
                  </div>
                </Form.Group>
              </div>
            </div>

            {/* Additional form rows remain the same */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="loanInterest">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Loan Interest
                    </Form.Label>
                    <CurrencyInput
                      name="loan interest"
                      decimalsLimit={2}
                      className="form-control"
                      value={loanInterest}
                      disabled
                      onValueChange={handleValueChange1}
                      style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="interest">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Interest
                    </Form.Label>
                    <CurrencyInput
                      name="interest"
                      decimalsLimit={2}
                      className="form-control"
                      value={interest}
                      disabled
                      onValueChange={handleValueChange2}
                      style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
                    />
                  </div>
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="totalRepayment">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Total Repayment
                    </Form.Label>
                    <CurrencyInput
                      name="total repayment"
                      decimalsLimit={2}
                      className="form-control"
                      value={totalRepayment}
                      disabled
                      onValueChange={handleValueChange3}
                      style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="duration">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Duration (Months)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="duration"
                      value={duration}
                      onChange={(e) => setDuration(e.target.value)}
                      required
                      style={{ flex: 1 }}
                    />
                  </div>
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="monthlyDeduction">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Monthly Deduction
                    </Form.Label>
                    <CurrencyInput
                      name="monthly deduction"
                      decimalsLimit={2}
                      className="form-control"
                      value={monthlyDeduction}
                      disabled
                      onValueChange={handleValueChange4}
                      style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="selectBank">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Select Bank
                    </Form.Label>
                    <div style={{ flex: 1 }}>
                      <Select
                        value={selectedBanks}
                        onChange={(selectedOption) => handleBankChange(selectedOption)}
                        options={banks}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: '200px',
                            overflowY: 'auto',
                          }),
                          control: (provided) => ({
                            ...provided,
                            width: '100%',
                          }),
                        }}
                      />
                    </div>
                  </div>
                </Form.Group>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button style={{ borderRadius: 0 }} variant='success' onClick={createLoan} >
            {createLoading ? (
              <>
                <Spinner size='sm' />
                <span style={{ marginLeft: '5px' }}>Creating, Please wait...</span>
              </>
            ) : (
              "Create New Loan"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Remittance Modal */}
      <Modal size="lg" show={showRemittanceModal} onHide={() => setShowRemittanceModal(false)} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 16, fontWeight: 'bold' }}>Add Receipt</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Transaction Date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                    style={{ fontSize: 14 }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Customer
                  </Form.Label>
                  <Select
                    onChange={handleCustomerChange}
                    options={cus}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({
                        ...base,
                        fontSize: 14,
                        minHeight: 38,
                      }),
                      singleValue: (base) => ({ ...base, fontSize: 14 }),
                    }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Outstanding
                  </Form.Label>
                  <CurrencyInput
                    name="amount"
                    decimalsLimit={2}
                    className="form-control"
                    value={outstanding}
                    disabled
                    style={{
                      textAlign: "right",
                      border: "1px solid #e4e4e4",
                      fontSize: 14,
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Description
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={1}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    style={{ fontSize: 14 }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Payment Mode
                  </Form.Label>
                  <Form.Select
                    value={selectedPaymentMode}
                    onChange={handlePaymentModeChange}
                    style={{ fontSize: 14 }}
                  >
                    <option value="">Select Mode</option>
                    {paymentMethod.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Bank
                  </Form.Label>
                  <Select
                    onChange={handlePaymentChange}
                    options={
                      selectedPaymentMode === "1" || selectedPaymentMode === "3"
                        ? debit3
                        : selectedPaymentMode === "2" || selectedPaymentMode === "4"
                          ? debit4
                          : debit3
                    }
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({
                        ...base,
                        fontSize: 14,
                        minHeight: 38,
                      }),
                      singleValue: (base) => ({ ...base, fontSize: 14 }),
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Amount
                  </Form.Label>
                  <CurrencyInput
                    name="amount"
                    decimalsLimit={2}
                    className="form-control"
                    value={incomeAmount}
                    onValueChange={handleValueChanges}
                    style={{
                      textAlign: "right",
                      border: "1px solid #e4e4e4",
                      fontSize: 14,
                    }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Cheque / Teller No
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={teller}
                    onChange={(e) => setTeller(e.target.value)}
                    style={{ fontSize: 14 }}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" className={classes.btn1} onClick={setShowRemittanceModal}> Cancel</Button>
          <Button className={classes.btnss} variant='primary'
            onClick={createRemitance} >
            Make Payment
          </Button>
        </Modal.Footer>
        {create && (
          <div className={classes.overlay}>
            <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
          </div>
        )}
      </Modal>

      <RemitanceUpload isOpen={showRemittanceExcelModal} onClose={() => setShowRemittanceExcelModal(false)} animation={false} />

      {/* User section */}
      <div className={`${classes.user} ${classes.desktopOnly}`}>
        <div className={classes.userProfile} ref={userDropdownRef}>
          <div
            className={classes.userAvatar}
            onClick={() => setUserDropdownOpen(!userDropdownOpen)}
          >
            <p className={classes.usrnm}>
              {initials}
            </p>
          </div>

          {userDropdownOpen && (
            <div className={classes.userDropdown}>
              <div className={classes.userInfo}>
                <p className={classes.userName}>{user || 'User'}</p>
                <p className={classes.userEmail}>{userEmail || 'user@example.com'}</p>
              </div>
              <div className={classes.dropdownDivider}></div>
              <button
                type="button"
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  setShowChangePassword(true);
                  setUserDropdownOpen(false);
                }}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Change Password
              </button>

              <button onClick={() => navigate("/welcome")}
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Switch Account
              </button>

              <button
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  handleLogout();
                  setUserDropdownOpen(false);
                }}
              >
                <img src={stngs} alt="Logout" className={classes.dropdownIcon} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      <div className={classes.mobileOnly}>
        <button
          className={classes.hamburgerBtn}
          onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <FaRegTimesCircle /> : <CiMenuFries />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className={classes.mobileMenu}>
          <div className={classes.mobileMenuContent}>
            <div className={classes.mobileNav}>
              {navItems.map((item) => {
                const isActive = location.pathname.startsWith(item.path);
                const hasDropdown = dropdownMenus[item.label];

                return hasDropdown ? (
                  <div key={item.label} className={classes.mobileNavGroup}>
                    <div
                      className={`${classes.mobileNavItem} ${isActive ? classes.activeDropdown : ""
                        }`}
                      onClick={() =>
                        setOpenDropdown(openDropdown === item.label ? null : item.label)
                      }
                    >
                      {item.label}
                    </div>

                    {openDropdown === item.label && (
                      <div className={classes.mobileSubmenu}>
                        {dropdownMenus[item.label].map((sub, index) =>
                          sub.isUploadPayableModal ? (
                            <div
                              key={index}
                              style={{ cursor: "pointer" }}
                              className={classes.mobileSubmenuItem}
                              onClick={() => {
                                handleOpenUploadType();
                                setOpenDropdown(null);
                                setMobileMenuOpen(false);
                              }}
                            >
                              {sub.label}
                            </div>
                          ) : sub.isModal ? (
                            <div
                              key={index}
                              className={classes.mobileSubmenuItem}
                              onClick={() => {
                                setShowLoanModal(true);
                                setOpenDropdown(null);
                                setMobileMenuOpen(false);
                              }}
                            >
                              {sub.label}
                            </div>
                          ) : (
                            <NavLink
                              key={index}
                              to={sub.path}
                              onClick={() => {
                                setOpenDropdown(null);
                                setMobileMenuOpen(false);
                              }}
                              className={({ isActive }) =>
                                `${classes.mobileSubmenuItem} ${isActive ? classes.activeDropdown : ""
                                }`
                              }
                            >
                              {sub.label}
                            </NavLink>
                          )
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <NavLink
                    key={item.label}
                    to={item.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className={({ isActive }) =>
                      `${classes.mobileNavItem} ${isActive ? classes.activeDropdown : ""}`
                    }
                  >
                    {item.label}
                  </NavLink>
                );
              })}
            </div>

            <div className={classes.mobileProfile}>
              <p className={classes.userName}>{user || "User"}</p>
              <p className={classes.userEmail}>{userEmail || "user@example.com"}</p>

              <button
                className={classes.dropdownItemm}
                onClick={() => {
                  setShowChangePassword(true);
                  setMobileMenuOpen(false);
                }}
              >
                Change Password
              </button>

              <button
                className={classes.dropdownItemm}
                onClick={() => {
                  handleLogout();
                  setMobileMenuOpen(false);
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      <JournalModal
        isOpen={openJournalModal}
        onClose={() => setOpenJournalModal(false)}
      />
    </div>
  );
}